
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition détaillée, stratégie et avantages de l'omnicanal pour les entreprises modernes",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition omnicanal, explorez ses avantages et comprendre comment elle s'applique dans le monde des affaires pour une meilleure stratégie marketing.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition détaillée, stratégie et avantages de l'omnicanal pour les entreprises modernes",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition omnicanal, explorez ses avantages et comprendre comment elle s'applique dans le monde des affaires pour une meilleure stratégie marketing.",
        },
      ],
    };
  },
};
